import { toirMapissuesConfigDefault } from '@infotech/toir-4sides-front-core'
import { moduleCrudConfig, CRUDRoute } from './CRUDConfig'


export default {
  ...toirMapissuesConfigDefault,
  config: {
    ...toirMapissuesConfigDefault.config,
    moduleCrudConfig,
    CRUDRoute,
  },
}
